import { render, staticRenderFns } from "./PageLoader.vue?vue&type=template&id=4e41324c&scoped=true&"
import script from "./PageLoader.vue?vue&type=script&lang=ts&"
export * from "./PageLoader.vue?vue&type=script&lang=ts&"
import style0 from "./PageLoader.vue?vue&type=style&index=0&id=4e41324c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e41324c",
  null
  
)

export default component.exports